import type { WaitingFormConfirmation, WaitingFormData } from '../types'

/** Loose structural shape shared by gate predicates. */
export interface GateLikeWaitingForm {
    confirmation?: unknown
    fields?: ReadonlyArray<{ name?: string; type?: string } | null | undefined>
    resume_token?: unknown
    task_id?: unknown
}

export function gateHasRealInputField(waitingForm: unknown): boolean {
    const wf = (waitingForm ?? {}) as GateLikeWaitingForm
    const fields = Array.isArray(wf.fields) ? wf.fields : []
    return fields.some((f) => !!f && f.name !== 'confirm' && f.type !== 'boolean')
}

export function gateLooksLikeGate(waitingForm: unknown): boolean {
    const wf = (waitingForm ?? {}) as GateLikeWaitingForm
    return !!(wf.resume_token || wf.task_id)
}

export function gateIsActionable(waitingForm: unknown): boolean {
    if (!waitingForm || typeof waitingForm !== 'object') return false
    const wf = waitingForm as GateLikeWaitingForm
    if (wf.confirmation && typeof wf.confirmation === 'object') return true
    if (gateHasRealInputField(wf)) return true
    return gateLooksLikeGate(wf)
}

export function isConfirmationOnly(
    confirmation: unknown,
    fields: ReadonlyArray<{ name?: string; type?: string } | null | undefined>,
): boolean {
    const nonConfirmFields = (fields || []).filter(
        (f) => f && f.name !== 'confirm' && f.type !== 'boolean',
    )
    return !!confirmation && nonConfirmFields.length === 0
}

/**
 * When a persistence round-trip strips the rich `confirmation` preview but keeps
 * the resume handle, reconstruct a minimal confirmation so the approval card
 * still renders.
 */
export function resolveConfirmationForContext(
    data: WaitingFormData,
): WaitingFormConfirmation | undefined {
    if (data.confirmation && typeof data.confirmation === 'object') {
        return data.confirmation
    }
    if (gateLooksLikeGate(data) && !gateHasRealInputField(data)) {
        return {
            tool_name: data.tool_name,
            confirm_message:
                data.prompt || data.original_request || 'Confirm this action to continue.',
            risk_level: 'high',
        }
    }
    return undefined
}
